import React, { useState } from 'react';
import './Contacto.css';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import TextareaAutosize from 'react-textarea-autosize';
import emailjs from 'emailjs-com';
// import ReCAPTCHA from 'react-google-recaptcha';
import CheckValue from '../../lib/formatValidations';

Modal.setAppElement('#root');

const Contacto = () => {
  const [categoryValue, setCategoryValue] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [contactName, setContactName] = useState('');
  const [businessPhoneNumber, setBusinessPhoneNumber] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [businessState, setBusinessState] = useState('');
  const [businessCity, setBusinessCity] = useState('');
  const [message, setMessage] = useState('');
  const [businessMode, setBusinessMode] = useState(false);
  const [privacyCheckbox, setPrivacyCheckbox] = useState(false);
  const [successRecaptcha, setSuccessRecaptcha] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [formIsComplete, setFormIsComplete] = useState(false);
  const [categoryValueAlert, setCategoryValueAlert] = useState('');
  const [businessNameAlert, setBusinessNameAlert] = useState('');
  const [contactNameAlert, setContactNameAlert] = useState('');
  const [businessPhoneNumberAlert, setBusinessPhoneNumberAlert] = useState('');
  const [contactEmailAlert, setContactEmailAlert] = useState('');
  const [businessStateAlert, setBusinessStateAlert] = useState('');
  const [businessCityAlert, setBusinessCityAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [privacyCheckboxAlert, setPrivacyCheckboxAlert] = useState('');
  const [successRecaptchaAlert, setSuccessRecaptchaAlert] = useState('');
  const emailjsRouting = () => {
    switch (categoryValue) {
      case 'business-registration':
        return {
          serviceId: 'service_04a5om9',
          templateId: 'template_9hr8gya',
          userId: 'user_UYQFJzjxhj68FkO6otn5T',
        };
      case 'tech-support':
        return {
          serviceId: 'service_vhvlxes',
          templateId: 'template_sf9d9mu',
          userId: 'user_dBLh6Yr4lUSGpuf9E46gs',
        };
      case 'work-with-us':
        return {
          serviceId: 'service_nqibcs7',
          templateId: 'template_rckjxtm',
          userId: 'user_zyxl9L3UvAKLuMIPn2OdM',
        };
      case 'data-privacy':
        return {
          serviceId: 'service_z1qe9yk',
          templateId: 'template_kwzesxr',
          userId: 'user_rKTwtzGc7MEadCJ72n7qR',
        };
      case 'other':
        return {
          serviceId: 'service_vhvlxes',
          templateId: 'template_sf9d9mu',
          userId: 'user_dBLh6Yr4lUSGpuf9E46gs',
        };
      default:
        return {
          serviceId: 'service_vhvlxes',
          templateId: 'template_sf9d9mu',
          userId: 'user_dBLh6Yr4lUSGpuf9E46gs',
        };
    }
  };

  const sendLead = (e) => {
    e.preventDefault();

    console.log({
      businessName,
      contactName,
      businessPhoneNumber,
      contactEmail,
      businessState,
      businessCity,
    });

    fetch(process.env.REACT_APP_ZAPIER_LEADS_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        businessName,
        contactName,
        businessPhoneNumber,
        contactEmail,
        businessState,
        businessCity,
      }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const resetFields = () => {
    setBusinessName('');
    setContactName('');
    setBusinessPhoneNumber('');
    setContactEmail('');
    setBusinessState('');
    setBusinessCity('');
    setMessage('');
    setPrivacyCheckbox(false);
  };

  // const handleRecaptcha = () => {
  //   setSuccessRecaptcha(true);
  //   setSuccessRecaptchaAlert('');
  // };

  const handleSelectChange = (e) => {
    handleInputChange(e);
    if (e.target.value === 'business-registration') {
      setBusinessMode(true);
      console.log('BUSINESS MODE ' + e.target.value);
    } else {
      setBusinessMode(false);
      console.log('CONTACT MODE ' + e.target.value);
      setBusinessName('');
      setBusinessPhoneNumber('');
      setBusinessState('');
      setBusinessCity('');
    }
  };

  const handleCheckboxChange = (e) => {
    handleInputChange(e);
    setFormIsComplete(true);
  };

  const handleInputChange = (e) => {
    const value =
      e.target.name === 'privacyCheckbox' ? e.target.checked : e.target.value;
    
    switch (e.target.name) {
      case 'categoryValue':
        setCategoryValue(value);
        break;
      case 'businessName':
        setBusinessName(value);
        break;
      case 'contactName':
        setContactName(value);
        break;
      case 'businessPhoneNumber':
        setBusinessPhoneNumber(value);
        break;
      case 'contactEmail':
        setContactEmail(value);
        break;
      case 'businessState':
        setBusinessState(value);
        break;
      case 'businessCity':
        setBusinessCity(value);
        break;
      case 'message':
        setMessage(value);
        break;
      case 'privacyCheckbox':
        setPrivacyCheckbox(value);
        break;
      default:
        break;
    }
  };

  const sendEmail = (e) => {
    let hasErrors = false;
    e.preventDefault();
    if (businessMode) {
      // Validation statement for BUSINESS mode
      if (categoryValue === '') {
        setCategoryValueAlert('Debes seleccionar una categoría');
        hasErrors = true;
      } else {
        setCategoryValueAlert('');
      }
      if (!CheckValue('empty', businessName)) {
        setBusinessNameAlert('Debes escribir el nombre de la empresa');
        hasErrors = true;
      } else {
        setBusinessNameAlert('');
      }
      if (!CheckValue('empty', contactName)) {
        setContactNameAlert('Debes escribir tu nombre');
        hasErrors = true;
      } else {
        setContactNameAlert('');
      }
      if (!CheckValue('empty', businessPhoneNumber)) {
        setBusinessPhoneNumberAlert('Debes escribir un número telefónico');
        hasErrors = true;
      } else if (businessPhoneNumber.length !== 10) {
        setBusinessPhoneNumberAlert(
          'El número telefónico debe de tener 10 dígitos'
        );
        hasErrors = true;
      } else {
        setBusinessPhoneNumberAlert('');
      }
      if (!CheckValue('empty', contactEmail)) {
        setContactEmailAlert('Debes escribir un correo electrónico');
        hasErrors = true;
      } else if (!CheckValue('email', contactEmail)) {
        setContactEmailAlert(
          'El correo electrónico debe tener este formato: ejemplo@mail.com'
        );
        hasErrors = true;
      } else {
        setContactEmailAlert('');
      }
      if (!CheckValue('empty', businessState)) {
        setBusinessStateAlert('Debes seleccionar un Estado');
        hasErrors = true;
      } else {
        setBusinessStateAlert('');
      }
      if (!CheckValue('empty', businessCity)) {
        setBusinessCityAlert('Debes seleccionar una Ciudad');
        hasErrors = true;
      } else {
        setBusinessCityAlert('');
      }
      if (!CheckValue('empty', message)) {
        setMessageAlert('Debes escribir un mensaje');
        hasErrors = true;
      } else {
        setMessageAlert('');
      }
      if (!privacyCheckbox) {
        setPrivacyCheckboxAlert('Debes aceptar la Política de Privacidad');
        hasErrors = true;
      } else {
        setPrivacyCheckboxAlert('');
      }
      // if (!successRecaptcha) {
      //   setSuccessRecaptchaAlert('Debes pasar el reCAPTCHA');
      //   hasErrors = true;
      // } else {
      //   setSuccessRecaptchaAlert('');
      // }
      console.log('test' + hasErrors);
      if (hasErrors) {
        console.log('Error en BUSINESS');
      } else {
        const routing = emailjsRouting();
        emailjs
          .sendForm(
            routing.serviceId,
            routing.templateId,
            e.target,
            routing.userId
          )
          .then(
            (result) => {
              console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
          );
        sendLead(e);
        resetFields();
        setSuccessModalVisible(true);
        console.log('El envío de BUSINESS mode está conectado');
      }
    } else {
      // Validation statement for CONTACT mode
      if (categoryValue === '') {
        setCategoryValueAlert('Debes seleccionar una categoría');
        hasErrors = true;
      } else {
        setCategoryValueAlert('');
      }
      if (!CheckValue('empty', contactName)) {
        setContactNameAlert('Debes escribir tu nombre');
        hasErrors = true;
      } else {
        setContactNameAlert('');
      }
      if (!CheckValue('empty', contactEmail)) {
        setContactEmailAlert('Debes escribir un correo electrónico');
        hasErrors = true;
      } else if (!CheckValue('email', contactEmail)) {
        setContactEmailAlert(
          'El correo electrónico debe tener este formato: ejemplo@mail.com'
        );
        hasErrors = true;
      } else {
        setContactEmailAlert('');
      }
      if (!CheckValue('empty', message)) {
        setMessageAlert('Debes escribir un mensaje');
        hasErrors = true;
      } else {
        setMessageAlert('');
      }
      if (!privacyCheckbox) {
        setPrivacyCheckboxAlert('Debes aceptar la Política de Privacidad');
        hasErrors = true;
      } else {
        setPrivacyCheckboxAlert('');
      }
      // if (!successRecaptcha) {
      //   setSuccessRecaptchaAlert('Debes pasar el reCAPTCHA');
      //   hasErrors = true;
      // } else {
      //   setSuccessRecaptchaAlert('');
      // }
      console.log('test' + hasErrors);
      if (hasErrors) {
        console.log('Error en CONTACT');
      } else {
        const routing = emailjsRouting();
        emailjs
          .sendForm(
            routing.serviceId,
            routing.templateId,
            e.target,
            routing.userId
          )
          .then(
            (result) => {
              console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
          );
        e.target.reset();
        resetFields();
        setSuccessModalVisible(true);
        console.log('El envío de CONTACT mode está conectado');
      }
    }
  };

  return (
      <>
        {/* <div className='NavBar-area'></div> */}
        <div className='contact-container'>
            <div className='single-row'>
              <label className='contact-title'>¡Contáctanos!</label>
            </div>
          <form onSubmit={sendEmail} className='form-container'>
            <div className='single-row '>
              <select
                value={categoryValue}
                className={
                  categoryValueAlert ? 'select-box red-border' : 'select-box'
                }
                name='categoryValue'
                onChange={handleSelectChange}
              >
                <option value=''>Selecciona una Categoría</option>
                <option value='business-registration'>
                  Atención a Empresas
                </option>
                <option value='tech-support'>Soporte Técnico</option>
                <option value='work-with-us'>Trabaja con Nosotros</option>
                <option value='data-privacy'>Privacidad de Datos</option>
                <option value='other'>Otro</option>
              </select>
            </div>
            <div className='single-row blank-div'>
              <span className='alertSpan'>
                {categoryValueAlert ? categoryValueAlert : null}
              </span>
            </div>
            <div className='single-row'>
              <input
                type='text'
                placeholder='Nombre de Negocio'
                className={
                  businessNameAlert ? 'text-box red-border' : 'text-box'
                }
                name='businessName'
                value={businessName}
                onChange={handleInputChange}
                style={{ display: businessMode ? 'block' : 'none' }}
              />
            </div>
            {businessMode ? (
              <div className='single-row blank-div'>
                <span className='alertSpan'>
                  {businessNameAlert ? businessNameAlert : null}
                </span>
              </div>
            ) : null}

            <div className='single-row'>
              <input
                type='text'
                placeholder='Nombre de Contacto'
                className={
                  contactNameAlert ? 'text-box red-border' : 'text-box'
                }
                name='contactName'
                value={contactName}
                onChange={handleInputChange}
              />
            </div>
            <div className='single-row blank-div'>
              <span className='alertSpan'>
                {contactNameAlert ? contactNameAlert : null}
              </span>
            </div>

            <div className='single-row'>
              <input
                type='number'
                placeholder='Escribe tu número de teléfono'
                className={
                  businessPhoneNumberAlert ? 'text-box red-border' : 'text-box'
                }
                name='businessPhoneNumber'
                value={businessPhoneNumber}
                onChange={handleInputChange}
                style={{ display: businessMode ? 'block' : 'none' }}
              />
            </div>
            {businessMode ? (
              <div className='single-row blank-div'>
                <span className='alertSpan'>
                  {businessPhoneNumberAlert ? businessPhoneNumberAlert : null}
                </span>
              </div>
            ) : null}

            <div className='single-row'>
              <input
                type='email'
                placeholder='Email'
                className={
                  contactEmailAlert ? 'text-box red-border' : 'text-box'
                }
                name='contactEmail'
                value={contactEmail}
                onChange={handleInputChange}
              />
            </div>
            <div className='single-row blank-div'>
              <span className='alertSpan'>
                {contactEmailAlert ? contactEmailAlert : null}
              </span>
            </div>

            <div className='single-row'>
              <div className='left-mail'>
                <input
                  type='text'
                  placeholder='Estado'
                  className={
                    businessStateAlert ? 'text-box red-border' : 'text-box'
                  }
                  name='businessState'
                  value={businessState}
                  onChange={handleInputChange}
                  style={{
                    display: businessMode ? 'block' : 'none',
                  }}
                />
                {businessMode ? (
                  <div className='single-row blank-div'>
                    <span className='alertSpan'>
                      {businessStateAlert ? businessStateAlert : null}
                    </span>
                  </div>
                ) : null}
              </div>
              <div className='right-mail'>
                <input
                  type='text'
                  placeholder='Ciudad'
                  className={
                    businessCityAlert ? 'text-box red-border' : 'text-box'
                  }
                  name='businessCity'
                  value={businessCity}
                  onChange={handleInputChange}
                  style={{
                    display: businessMode ? 'block' : 'none',
                  }}
                />
                {businessMode ? (
                  <div className='single-row blank-div'>
                    <span className='alertSpan'>
                      {businessCityAlert ? businessCityAlert : null}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>

            <div className='single-row'>
              <TextareaAutosize
                placeholder='Escribe un Mensaje'
                className={
                  messageAlert
                    ? 'text-box textarea-autosize red-border'
                    : 'text-box textarea-autosize'
                }
                minRows='5'
                name='message'
                value={message}
                onChange={handleInputChange}
              ></TextareaAutosize>
            </div>
            <div className='single-row blank-div'>
              <span className='alertSpan'>
                {messageAlert ? messageAlert : null}
              </span>
            </div>

            <div className='single-row'>
              <input
                type='checkbox'
                checked={privacyCheckbox}
                name='privacyCheckbox'
                onChange={handleCheckboxChange}
              />
              <span className='text-after-checkbox'>
                He leído y aceptado los{' '}
                <Link className='privacy-link' to='/terminos' target='_top'>
                  Términos y Condiciones
                </Link>
                .
              </span>
            </div>
            <div className='single-row blank-div'>
              <span className='alertSpan'>
                {privacyCheckboxAlert ? privacyCheckboxAlert : null}
              </span>
            </div>

            {/* <ReCAPTCHA
              sitekey='6Lfh8eQZAAAAAKQE_NPOpquFD5ecoS2xe_Bv9rFx'
              onChange={this.handleRecaptcha}
            ></ReCAPTCHA> */}
            {/* <div className='single-row blank-div'>
              <span className='alertSpan'>
                {successRecaptchaAlert ? successRecaptchaAlert : null}
              </span>
            </div> */}
            <div className='single-row'>
              <input
                type='submit'
                value='Enviar'
                className={
                  formIsComplete
                    ? 'send-button green-submit-button'
                    : 'send-button'
                }
                disabled={!formIsComplete}
              />
            </div>
            <Modal
              isOpen={successModalVisible}
              // onRequestClose={() => setModalIsOpen(false)}
              style={{
                overlay: {
                  backgroundColor: 'transparent',
                },
                content: {
                  top: '50%',
                  left: '50%',
                  right: 'auto',
                  bottom: 'auto',
                  marginRight: '-50%',
                  transform: 'translate(-50%, -50%)',
                },
              }}
            >
              <div className='div-modal'>
                <h2>Mensaje enviado</h2>
                <br />
                <p>¡Gracias!</p>
                <p>Recibirás respuesta en tu buzón de e-mail.</p>
                <div className='div-modal-button'>
                  <button
                    className='button-modal'
                    onClick={() =>
                      setSuccessModalVisible(false)
                    }
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </Modal>
          </form>
        </div>
      </>
    );
};

export default Contacto;
